<template>
    <h2 v-if="model != undefined && model.Size === 'Two'">{{ model.Text }}</h2>
    <h1 v-else-if="model != undefined">{{ model.Text }}</h1>
</template>

<script>
export default {
    name: "HeaderTwo",
    props: {
        model: Object
    },
}
</script>

<style lang="scss" scoped>
h2 {
    padding: $spacer-three $spacer-two;
}

h1, h2, h3, h4 {
    &.text-align-left {
        text-align: left;
    }
}
</style>